module.exports = __webpack_public_path__ + "img/wheel.b33df34c.png";